
import Splash from "../Pages/Splash";
import Home from "../Pages/Home/Home";
import VendorsList from "../Pages/Vendors/VendorsList";
import VendorProducts from "../Pages/Vendors/VendorProducts";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import Register from "../Pages/Auth/Register";
import Cart from "../Pages/Orders/Cart";
import AddAddress from "../Pages/Profile/AddAddress";
import Profile from "../Pages/Profile/Profile";
import Orders from "../Pages/Orders/Orders";
import Order from "../Pages/Orders/Order";
import Content from "../Pages/Profile/Content";
import SearchProducts from "../Pages/Home/SearchProducts";
import Scores from "../Pages/Home/Scores";
import Product from "../Pages/Vendors/Product";
import InviteOthers from "../Pages/Profile/InviteOthers";
import Reagent from "../Pages/Auth/Reagent";
import Discounts from "../Pages/Home/Discounts";
import Reagents from "../Pages/Profile/Reagents";
import FavoriteVendorsList from "../Pages/Vendors/FavoriteVendorsList";
import EditProfile from "../Pages/Profile/EditProfile";
import VendorInfo from "../Pages/Vendors/VendorInfo";
import ManageAddresses from "../Pages/Profile/ManageAddresses";
import EditAddress from "../Pages/Profile/EditAddress";
import ScoreDetails from "../Pages/Home/ScoreDetails";
import ReagentVendors from "../Pages/Profile/ReagentVendors";
import VendorOrders from "../Pages/Vendors/VendorOrders";
import Wallet from "../Pages/Profile/Wallet";


const appRoutes = [
    {
        pageId : 0,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 1,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 2,
        path: "/home/vendors/:id",
        component: <VendorsList />,
    },
    {
        pageId : 3,
        path: "/vendor/:id",
        component: <VendorProducts />,
    },
    {
        pageId : 4,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 5,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 6,
        path: "/register",
        component: <Register />,
    },
    {
        pageId : 7,
        path: "/cart",
        component: <Cart />,
    },
    {
        pageId : 8,
        path: "/add-address",
        component: <AddAddress />,
    },
    {
        pageId : 9,
        path: "/profile",
        component: <Profile />,
    },
    {
        pageId : 10,
        path: "/orders",
        component: <Orders />,
    },
    {
        pageId : 11,
        path: "/orders/:id",
        component: <Order />,
    },
    {
        pageId : 12,
        path: "/contents/:slug",
        component: <Content />,
    },
    {
        pageId : 13,
        path: "/search",
        component: <SearchProducts />,
    },
    {
        pageId : 14,
        path: "/scores",
        component: <Scores />,
    },
    {
        pageId : 15,
        path: "/vendor/:id/:pid",
        component: <Product />,
    },
    {
        pageId : 16,
        path: "/profile/invite-others",
        component: <InviteOthers />,
    },
    {
        pageId : 17,
        path: "/invite/:code",
        component: <Reagent />,
    },
    {
        pageId : 18,
        path: "/discounts",
        component: <Discounts />,
    },
    {
        pageId : 19,
        path: "/reagents",
        component: <Reagents />,
    },
    {
        pageId : 20,
        path: "/favorites/vendors",
        component: <FavoriteVendorsList />,
    },
    {
        pageId : 21,
        path: "/edit-profile",
        component: <EditProfile />,
    },
    {
        pageId : 22,
        path: "/vendor/info/:id",
        component: <VendorInfo />,
    },
    {
        pageId : 23,
        path: "/addresses",
        component: <ManageAddresses />,
    },
    {
        pageId : 24,
        path: "/edit-address/:id",
        component: <EditAddress />,
    },
    {
        pageId : 25,
        path: "/scores/:id",
        component: <ScoreDetails />,
    },
    {
        pageId : 26,
        path: "/reagent-vendors",
        component: <ReagentVendors />,
    },

    {
        pageId : 27,
        path: "/vendor-orders/:id",
        component: <VendorOrders />,
    },

    {
        pageId : 28,
        path: "/wallet",
        component: <Wallet />,
    },
];
export default appRoutes;
